import { PropsWithChildren } from "react"
import cn from "classnames"

import style from "./style.module.scss"

import { Spinner } from "components/Spinner"

interface Props {
    className?: string
    isLoading?: boolean
    fitHeight?: boolean
}

export function Layout({
    className,
    children,
    isLoading,
    fitHeight = false,
}: PropsWithChildren<Props>) {
    return (
        <div
            className={cn(
                style.container,
                {
                    [style.fitHeight]: fitHeight,
                },
                className ? className : "page-common"
            )}
        >
            {isLoading ? <Spinner /> : children}
        </div>
    )
}

export function LayoutWithSpinner({ className }: Props) {
    return (
        <Layout className={className}>
            <Spinner />
        </Layout>
    )
}
